import { render, staticRenderFns } from "./db-recipients-import.vue?vue&type=template&id=26b645ac&"
import script from "./db-recipients-import.vue?vue&type=script&lang=js&"
export * from "./db-recipients-import.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports